// removed by extract-text-webpack-plugin
module.exports = {"msgContainer":"_1ra7x8C65sEEaxuYQAab1C","msg":"yEkzvYhyeInXpf7TH4PxB","imageContainer":"i2eoatmE7Nkks2kCEdwqs","textContainer":"_1eA6-lpPklWfdYJnNqur9l"};


//////////////////
// WEBPACK FOOTER
// ./components/noResults.scss
// module id = 1618
// module chunks = 0